import {Grid, Typography, useTheme} from "@mui/material";
import FormControl from "@mui/material/FormControl/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup/RadioGroup";
import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {FormAlertModel} from "../../../api/types/alert";
import Radio from "@mui/material/Radio";
import {FormAutocomplete} from "../../../common/form-fields";
import FormTimePicker from "../../../common/form-fields/FormTimePicker";
import dayjs from "dayjs";

type Props = {
    readonly: boolean;
}

const WeeklyScheduler = ({readonly}: Props) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    const daysOfTheWeek = [
        {code: 0, label: dayjs().day(0).format("dddd")},
        {code: 1, label: dayjs().day(1).format("dddd")},
        {code: 2, label: dayjs().day(2).format("dddd")},
        {code: 3, label: dayjs().day(3).format("dddd")},
        {code: 4, label: dayjs().day(4).format("dddd")},
        {code: 5, label: dayjs().day(5).format("dddd")},
        {code: 6, label: dayjs().day(6).format("dddd")}
    ];

    //USE FORM CONTEXT
    const {register, watch} = useFormContext<FormAlertModel>();

    // Use Theme
    const theme = useTheme();

    return (
        <>
            <Grid container spacing={2} p={2} alignItems="start">
                <Grid container spacing={2} p={2} alignItems="start">
                    <Typography variant="h6" width={"100%"} pl={2} mt={4}>
                        {t("pricing:alert.labels.weeklySchedule")}
                    </Typography>
                    <Grid item xs={12}>
                        <FormControl sx={{width: "100%"}}>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                color={"accent"}
                                defaultValue={t("pricing:alert.labels.every")}>
                                <Grid
                                    container
                                    spacing={2}
                                    p={2}
                                    alignItems="center">
                                    <Grid item xs={12} md={3}>
                                        <FormControlLabel
                                            value={t(
                                                "pricing:alert.labels.every"
                                            )}
                                            sx={{
                                                width: "100%",
                                                "& .MuiFormControlLabel-label":
                                                    {
                                                        width: "100%"
                                                    }
                                            }}
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: theme.palette
                                                            .accent.main,
                                                        "&.Mui-checked": {
                                                            color: theme.palette
                                                                .accent.main
                                                        },
                                                        padding: 0,
                                                        marginRight: "9px"
                                                    }}
                                                />
                                            }
                                            label={
                                                <FormAutocomplete
                                                    multiple={true}
                                                    {...register("crons.weeklyDays")}
                                                    label={t("pricing:alert.labels.every")}
                                                    options={daysOfTheWeek}
                                                    isOptionEqualToValue={(option, value) => option.code === value.code}
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    {/* START TIME */}
                    <Grid item xs={12} md={3}>
                        <FormTimePicker
                            {...register("crons.startTime")}
                            label="START TIME*"
                            readOnly={readonly}
                        />
                    </Grid>
                    {/* ADD TIME */}
                    <Grid item xs={12} md={3}>
                        <FormTimePicker
                            {...register("crons.addTime")}
                            label="ADD TIME"
                            readOnly={readonly || !watch("crons.startTime")}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default WeeklyScheduler;
